

























































import {Component, Prop, Vue} from "vue-property-decorator";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import {ifValid, processError} from "@/utils/ComponentUtils";
import {namespace} from "vuex-class";
import SelectOption from "@/components/common/SelectOption";
import AddContractorDocumentPayload from "@/dto/contractor/AddContractorDocumentPayload";
import IndividualForeignContractorService from "@/components/payroll/business/employments/foreignContractors/IndividualForeignContractorService";
import {ContractorDocumentType} from "@/constants/ContractorConstants";
import {ContractorType} from "@/dto/payroll/IEmployment";
import IndividualContractorService
  from "@/components/payroll/business/employments/contractors/IndividualContractorService";
import BusinessForeignContractorService
  from "@/components/payroll/business/employments/foreignContractors/BusinessForeignContractorService";
import BusinessContractorService from "@/components/payroll/business/employments/contractors/BusinessContractorService";

const AppModule = namespace("App");

@Component({
  components: {
    SingleFileHolder,
    PortalDate,
    PortalSelect,
    PortalInput
  }
})
export default class AddContractorDocumentModal extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  @Prop()
  private onSuccess!: () => void

  @Prop()
  private contractorType!: ContractorType

  private payload = new AddContractorDocumentPayload();
  private isValidFile = true;

  addContractorDocument(): void {
    this.isValidFile = !!this.payload.file;
    ifValid(this, () => {
      if (this.isValidFile) {
        this.startLoading();
        switch(this.contractorType){
          case ContractorType.INDIVIDUAL_FOREIGN:
            IndividualForeignContractorService.addDocument(this.contractorId, this.payload).then(
                () => {
                  this.stopLoading();
                  this.$modal.hideAll();
                  this.onSuccess();
                },
                error => {
                  processError(error, this);
                  this.stopLoading();
                }
            );
            break
          case ContractorType.INDIVIDUAL_DOMESTIC:
            IndividualContractorService.addDocument(this.contractorId, this.payload).then(
                () => {
                  this.stopLoading();
                  this.$modal.hideAll();
                  this.onSuccess();
                },
                error => {
                  processError(error, this);
                  this.stopLoading();
                }
            );
            break
          case ContractorType.BUSINESS_FOREIGN:
            BusinessForeignContractorService.addDocument(this.contractorId, this.payload).then(
                () => {
                  this.stopLoading();
                  this.$modal.hideAll();
                  this.onSuccess();
                },
                error => {
                  processError(error, this);
                  this.stopLoading();
                }
            );
            break
          case ContractorType.BUSINESS_DOMESTIC:
            BusinessContractorService.addDocument(this.contractorId, this.payload).then(
                () => {
                  this.stopLoading();
                  this.$modal.hideAll();
                  this.onSuccess();
                },
                error => {
                  processError(error, this);
                  this.stopLoading();
                }
            );
            break
        }
      }
    });
  }

  buildTypes(): Array<SelectOption> {
    if (!this.isForeignContractor){
      return [SelectOption.builder().title("Form W9").value(ContractorDocumentType.FORM_W9).build()];
    } else if (this.contractorType === ContractorType.INDIVIDUAL_FOREIGN){
      return [SelectOption.builder().title("Form W-8BEN").value(ContractorDocumentType.FORM_W_8BEN).build()];
    }
    else {
      return [SelectOption.builder().title("Form W-8BEN-E").value(ContractorDocumentType.FORM_W_8BEN_E).build()];
    }
  }

  private buildStates(): Array<SelectOption> {
    return this.$states.map(s =>
        SelectOption.builder().title(s).value(s).build()
    );
  }

  get contractorId(): number {
    return Number.parseInt(this.$route.params.contractorId);
  }


  get isForeignContractor(): boolean{
    return this.contractorType === ContractorType.INDIVIDUAL_FOREIGN || this.contractorType === ContractorType.BUSINESS_FOREIGN
  }


}
